module.exports = __webpack_public_path__ + "static/img/grade_15.29e1248.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_15.png
// module id = 6a9x
// module chunks = 89